import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './input_social_midias.css';

const InputSocialMedia = ({ icon, name, placeholder, value, onChange, dataSection, dataSubsection }) => {
    return (
        <div className="CampoRedeSocial">
            <FontAwesomeIcon icon={icon} className="IconeRedeSocial" />
            <input
                type="text"
                name={name}
                placeholder={placeholder}
                data-section={dataSection}
                data-subsection={dataSubsection}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};

export default InputSocialMedia;
